import { produce } from 'immer';

import { SET_FUNDS_TRANSFER_CONFIG } from './actions';

export const defaultState = {
    fundsTransferConfig: {
        isLoaded: false,
        allowedByAgeVerification: false,
        clubBalance: 0,
        remainingLimits: [],
        allowedToTransfer: {
            value: 0,
            label: 0
        },
        configuredDailyLimit: 0,
        configuredMonthlyLimit: 0,
        configuredWeeklyLimit: 0,
        shouldShowFundsTransferPrompt: false
    }
};

export const reducer = produce((draftState, action) => {
    switch (action.type) {
        case SET_FUNDS_TRANSFER_CONFIG: {
            draftState.fundsTransferConfig = action.payload;
            break;
        }
        default:
            break;
    }
}, defaultState);
